import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="bg-ev-black px-4 pb-5 pt-5 text-white" data-id="element-75" data-mp="9kjuoj1ugu11">
      <div className="mx-auto max-w-3xl text-center" data-id="element-76" data-mp="9ipc3be1pe04">
        <h1 className="mb-2 font-display text-[26px] leading-[1.02] text-white sm:text-[46px]" data-id="element-77" data-mp="4mrul1r1q1lr">
          The Complete{' '}
          <span className="text-ev-green" data-id="element-78" data-mp="128yzydv6bxz6">Visual Troubleshooting System</span> for EV &amp; Hybrid
          Technicians
        </h1>
        <p className="mx-auto mb-3 max-w-2xl text-[13px] font-medium leading-snug text-ev-steel sm:text-base" data-id="element-79" data-mp="sbb2hg66ocdb">
          Stop jumping between scattered references every time an EV or hybrid fault appears. Use
          organized diagnostic workflows, system references and troubleshooting tools to understand
          faults and follow a clearer diagnostic process.{' '}
          <span className="font-bold text-white" data-id="element-80" data-mp="3814cxsua24px">Identify. Test. Diagnose with confidence.</span>
        </p>

        <a href={OFFER_ANCHOR} className="mb-3 block" aria-label="Go to the offer" data-id="element-81" data-mp="3j6fwnlhhz5bq">
          <img src={PRODUCT_IMG} alt="EV &amp; Hybrid Diagnostic Pro complete 6-in-1 system box set" className="mx-auto w-full max-w-[300px] object-contain drop-shadow-2xl transition-transform duration-150 ease-out hover:scale-[1.02] sm:max-w-[420px]" data-id="element-82" data-mp="3o6u87dib4xei" />
        </a>

        <CTAButton className="mx-auto mb-2 max-w-md" data-id="element-83" data-mp="30fy7trzsctvn">
          ⚡ YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>

        <p className="mb-1 font-cond text-base tracking-wide text-ev-neon sm:text-lg" data-id="element-84" data-mp="2qjv8sv08dbcx">
          GET EV &amp; HYBRID DIAGNOSTIC PRO™ TODAY
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-bold uppercase tracking-wide text-ev-steel sm:text-xs" data-id="element-85" data-mp="2vjq0h0rty4z1">
          <span className="flex items-center gap-1" data-id="element-86" data-mp="2lkin4dl3iabx">
            <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-ev-green" data-id="element-87" data-mp="2lk8ra9ddd8yb" />
            7-Day Money-Back Guarantee
          </span>
          <span className="flex items-center gap-1" data-id="element-88" data-mp="nbb9spq0zv12">
            <ZapIcon aria-hidden="true" className="h-4 w-4 text-ev-green" data-id="element-89" data-mp="n9qj5b6u0w8h" />
            Complete 6-in-1 System
          </span>
        </div>
      </div>
    </section>;
}